
export { useAmplitude } from "/builds/t2_e_sw-P/0/dd3tech/wiggot/wiggot-web/packages/analytics/src/providers/amplitud-provider/AmplitudeProvider.tsx"